// File: frontend/src/components/pages/home/CTA.js

import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useLanguage } from '../../../hooks/useLanguage';
import { ArrowRight } from 'lucide-react';
import AuthModal from '../../auth/AuthModal';
import styles from './CTA.module.css';
import { ASSETS_BASE_URL } from '../../../config/constants';

const CTA = () => {
  const { t, parseHTML } = useLanguage();
  const { isAuthenticated } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  // Preload background image
  useEffect(() => {
    const img = new Image();
    img.src = `${ASSETS_BASE_URL}/images/cta-aerial-toronto.png`;
    img.onload = () => setIsImageLoaded(true);
  }, []);

  if (isAuthenticated) return null;

  return (
    <section className={styles.section}>
      {/* Background image */}
      <div className={`${styles.bgImage} ${isImageLoaded ? styles.loaded : ''}`}>
        <img
          src={`${ASSETS_BASE_URL}/images/cta-aerial-toronto.png`}
          alt=""
          loading="lazy"
        />
        <div className={styles.bgOverlay} />
      </div>

      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.headline}>
            {parseHTML(
              t('cta.headline', '<stat>10,000+</stat> Canadians already know exactly what their insurance covers. <highlight>Do you?</highlight>'),
              {
                highlight: ({ children }) => <span className={styles.highlight}>{children}</span>,
                stat: ({ children }) => <span className={styles.stat}>{children}</span>
              }
            )}
          </h2>

          <p className={styles.subheadline}>
            {t('cta.subheadline', 'Upload your first policy in 60 seconds. Free forever. No credit card required.')}
          </p>

          <button
            className={styles.cta}
            onClick={() => setShowAuthModal(true)}
          >
            <span>{t('cta.button', 'Get Started Free')}</span>
            <ArrowRight size={18} strokeWidth={2.5} />
          </button>
        </div>
      </div>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        initialType="sign_up"
      />
    </section>
  );
};

export default CTA;